import dayjs, { Dayjs } from 'dayjs';

import { ProductState } from 'protocol/api/billing_new/dto_product_new_pb';

import { ProductStateTimestamp } from '../config';

export const getProductStateTimestampMillis = (
  timestamp?: ProductStateTimestamp,
): number => Number(timestamp?.seconds ?? 0) * 1000;

export const getSubscriptionStartMillis = (
  subscription: ProductState,
): number => getProductStateTimestampMillis(subscription.Start);

export const getSubscriptionEndMillis = (subscription: ProductState): number =>
  getProductStateTimestampMillis(subscription.End);

const ceilToMinute = (value: Dayjs): Dayjs =>
  value.second() === 0 && value.millisecond() === 0
    ? value
    : value.add(1, 'minute').startOf('minute');

export const getMinimumScheduledStartAt = (
  subscription?: ProductState,
): Dayjs => {
  const now = ceilToMinute(dayjs());

  if (!subscription?.End) {
    return now;
  }

  const subscriptionEnd = ceilToMinute(dayjs(subscription.End.toDate()));

  return subscriptionEnd.isAfter(now) ? subscriptionEnd : now;
};

export const getDefaultScheduledStartAt = (
  subscription?: ProductState,
): Dayjs | undefined => {
  if (!subscription?.End) {
    return undefined;
  }

  return getMinimumScheduledStartAt(subscription);
};
